import { userInfoItem } from '@/views/corporate-info/types/index'

export interface State {
  corporateInfo: userInfoItem
  corporatePageStatus: number
  corporateId: number
  corporateInfoCopy: userInfoItem
}

const state = (): State => ({
  corporateInfo: {
    corporate_id: null,
    corporate_number: null,
    corporate_name: '',
    corporate_name_sort: '',
    corporate_katakana: '',
    corporate_address: '',
    corporate_website: '',
    manager_given_name: '',
    manager_family_name: '',
    manager_kana: '',
    domain1: '',
    domain2: '',
    domain3: '',
    contract_start_date: '',
    contract_end_date: '',
    contract_status: '',
    contract_amount: 0,
    chem_value_contract_flag: '',
    ocr_contract_flag: '',
    ocr_read_target_flag2: '',
    ocr_read_target_flag3: '',
    ocr_read_target_flag9: '',
    ocr_read_target_flag14: '',
    ocr_read_target_flag15: '',
    mfa_contract_flag: '',
    invoice_recipient_address: '',
    invoice_delivery_method: '',
    remark: '',
    registration_date: '',
    inquiry_phone: '',
    manager_department: '',
    manager_email: '',
    manager_phone: '',
    manager_position: '',
    plan_category: '',
    plan_category_str: '',
    contract_status_str: '',
    chem_value_contract_flag_str: false,
    ocr_contract_flag_boolean: false,
    ocr_read_target_flag2_boolean: false,
    ocr_read_target_flag3_boolean: false,
    ocr_read_target_flag9_boolean: false,
    ocr_read_target_flag14_boolean: false,
    ocr_read_target_flag15_boolean: false,
    mfa_contract_flag_boolean: false,
    invoice_delivery_method_str: '',
    update_datetime: '',
    update_user_name: '',
    direct_sender_given_name: '',
    direct_sender_family_name: '',
    direct_sender_email: '',
    direct_sender_recipient_id: 0,
  },
  corporateInfoCopy: {
    corporate_id: null,
    corporate_number: null,
    corporate_name: '',
    corporate_name_sort: '',
    corporate_katakana: '',
    corporate_address: '',
    corporate_website: '',
    manager_given_name: '',
    manager_family_name: '',
    manager_kana: '',
    domain1: '',
    domain2: '',
    domain3: '',
    contract_start_date: '',
    contract_end_date: '',
    contract_status: '',
    contract_amount: 0,
    chem_value_contract_flag: '',
    ocr_contract_flag: '',
    ocr_read_target_flag2: '',
    ocr_read_target_flag3: '',
    ocr_read_target_flag9: '',
    ocr_read_target_flag14: '',
    ocr_read_target_flag15: '',
    mfa_contract_flag: '',
    invoice_recipient_address: '',
    invoice_delivery_method: '',
    remark: '',
    registration_date: '',
    inquiry_phone: '',
    manager_department: '',
    manager_email: '',
    manager_phone: '',
    manager_position: '',
    plan_category: '',
    plan_category_str: '',
    contract_status_str: '',
    chem_value_contract_flag_str: false,
    ocr_contract_flag_boolean: false,
    ocr_read_target_flag2_boolean: false,
    ocr_read_target_flag3_boolean: false,
    ocr_read_target_flag9_boolean: false,
    ocr_read_target_flag14_boolean: false,
    ocr_read_target_flag15_boolean: false,
    mfa_contract_flag_boolean: false,
    invoice_delivery_method_str: '',
    update_datetime: '',
    update_user_name: '',
    direct_sender_given_name: '',
    direct_sender_family_name: '',
    direct_sender_email: '',
    direct_sender_recipient_id: 0,
  },
  corporatePageStatus: 0,
  corporateId: -1,
})

export default state
